/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PatientsSidePanelFilter.vue?vue&type=template&id=1348ee74&scoped=true"
import script from "./PatientsSidePanelFilter.vue?vue&type=script&lang=js"
export * from "./PatientsSidePanelFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1348ee74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1348ee74')) {
      api.createRecord('1348ee74', component.options)
    } else {
      api.reload('1348ee74', component.options)
    }
    module.hot.accept("./PatientsSidePanelFilter.vue?vue&type=template&id=1348ee74&scoped=true", function () {
      api.rerender('1348ee74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/PatientsSidePanelFilter.vue"
export default component.exports